import { e as r, a, f as t, b as e, g as s } from "./helpers-C8k3UfPS.js";
var n = function (t) {
  function n(r) {
    var a;
    return e(this, n), (a = s(this, n, [r])).name = "SyntheticChangeError", a;
  }
  return r(n, t), a(n);
}(t(Error));
export { n as default };